import {Component, input, OnInit} from '@angular/core';
import {CardsBasicComponent} from "../../../shared/components/cards/cards-basic/cards-basic.component";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {Subscription} from "rxjs";
import {LanguageService} from "../../../shared/services/language.service";
import {AuthService} from "../../../shared/services/auth.service";
import {RouterLink} from "@angular/router";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-subscribtions',
  standalone: true,
  imports: [
    CardsBasicComponent,
    LocalizeRouterPipe,
    MatButton,
    TranslateModule,
    RouterLink
  ],
  templateUrl: './subscribtions.component.html',
  styleUrl: './subscribtions.component.css'
})
export class SubscribtionsComponent implements OnInit {
  productData!: any;
  currentLanguage!: string;
  userInfo: any;
  userProfile: any;
  productId = input<any>();

  private subscriptions: Subscription = new Subscription();
  private langChangeSubscription: Subscription | null = null;

  constructor(
    private _languageService: LanguageService,
    private _translate: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.setupLanguageSubscription();
    this.getUserProfile();
  }

  private getUserProfile() {
    if (!this.authService.isAuthenticated()) {
      console.log('User ist nicht eingeloggt, getUserProfile wird nicht aufgerufen.');
      return;
    }

    this.subscriptions.add(
      this.authService.getUserProfile().subscribe({
        next: (data: any) => {
          this.userProfile = data;
        },
        error: (error) => {
          console.error('Error fetching user profile', error);
        }
      })
    );
  }


  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }


}
